import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { navItems } from '../../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur" data-id="element-171" data-mp="lyqgo3xelo1k">
      <div className="hidden bg-ink text-cream-light md:block" data-id="element-172" data-mp="i0iz56v48ipb">
        <div className="mx-auto flex max-w-shell items-center justify-between px-8 py-2 text-[0.6875rem] uppercase tracking-label" data-id="element-173" data-mp="vqcrhz5txl3s">
          <p data-id="element-174" data-mp="qz4fcvd47lmx">Clinically directed care · Licensed in all 50 states</p>
          <p className="text-stone" data-id="element-175" data-mp="39tl7wq9sphr">Membership from $39/mo · Price held 12 months</p>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-6 md:px-8" data-id="element-176" data-mp="3uheisdmhiqdm">
        <div className="flex items-center justify-between py-5" data-id="element-177" data-mp="3uesaucvom8uv">
          <Link to="/" className="text-ink" aria-label="Republic home" data-id="element-178" data-mp="6uvlt9f131t2">
            <Logo className="text-base md:text-lg" data-id="element-179" data-mp="btzyia15vho5" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-180" data-mp="glhx4rfpp65y">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-150 ease-republic ${isActive ? 'text-brick' : 'text-ink-soft hover:text-ink'}`} data-id="element-181" data-mp="ll30rf5tu2p0">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-6 lg:flex" data-id="element-182" data-mp="1xn2h5i58rq8">
            <Link to="/pricing" className="text-sm text-ink-soft transition-colors duration-150 ease-republic hover:text-ink" data-id="element-183" data-mp="19afgkxvnt90a">
              Sign in
            </Link>
            <Link to="/get-started" className="bg-ink px-6 py-3 text-sm font-medium text-cream-light transition-colors duration-150 ease-republic hover:bg-brick" data-id="element-184" data-mp="3abvgokxbvtqy">
              Start intake
            </Link>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-185" data-mp="3jayxtjcxpz2t">
            {open ? <XIcon className="h-6 w-6" data-id="element-186" data-mp="2mntzyopzx70g" /> : <MenuIcon className="h-6 w-6" data-id="element-187" data-mp="2monbe2zwgkox" />}
          </button>
        </div>
        <div className="rule" data-id="element-188" data-mp="30ez70bvp11kt" />
      </div>

      <AnimatePresence data-id="element-189" data-mp="30g1sg4a8ybtc">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-ink/10 bg-cream lg:hidden" data-id="element-190" data-mp="2vmfrh9dg3wdd">
            <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-6" data-id="element-191" data-mp="if7rzj7aujlk">
              <ul className="flex flex-col" data-id="element-192" data-mp="n8j15qzl3cgn">
                {navItems.map(item => <li key={item.to} className="border-b border-ink/10" data-id="element-193" data-mp="9gvssssdadhi">
                    <Link to={item.to} className="block py-4 font-serif text-2xl text-ink" data-id="element-194" data-mp="ef7477yb8w1u">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/get-started" className="mt-6 inline-flex bg-ink px-6 py-3 text-sm font-medium text-cream-light" data-id="element-195" data-mp="166vc9ia22wev">
                Start intake
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}